import { browseCardsStoreName } from '../../components/Shared/Constants/Browse/BrowseConstants';

const initialState = {
  next: '',
  total: -1,
  results: [],
  shouldPerformSearch: false,
  isLoading: false,
};

const reducerName = browseCardsStoreName;

const browseCardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'Insert'.concat(reducerName):
      return {
        ...state,
        total: action.payload?.total ?? state.total,
        results: state.results.concat(
          action.payload.results.filter(
            incoming =>
              state.results.some(current => current.id === incoming.id) ===
              false,
          ),
        ),
        next: action.payload?.next ?? false,
      };
    case 'Clear'.concat(reducerName):
      return initialState;
    case 'ShouldPerformSearch'.concat(reducerName):
      return {
        ...state,
        shouldPerformSearch: action.payload,
      };
    case 'SetIsLoading'.concat(reducerName):
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
};

export default browseCardsReducer;
